const APIUrl =  {
    production: 'http://14.maitian.cn',
    qa: 'http://172.16.14.120:8000',
    dev: 'http://172.16.14.120:8000'
}
const uploadImgUrl = {
    production: 'http://image.maitian.cn',
    qa: 'http://172.16.10.204',
    dev: 'http://172.16.10.204'
}
export default {
    APIUrl: APIUrl[process.env.VUE_APP_ENV],
    uploadImgUrl: uploadImgUrl[process.env.VUE_APP_ENV]
}